module.exports = __webpack_public_path__ + "img/hipercard.e4f3b31d.svg";